// MN-8137: shared cart-sum resolver for the bulk-discount slider and the
// quantity-grid tier-priority lookup. `activeCart` may be a hydrating `{}`
// from saved-cart paths, so require a non-nullish `amount` before reading it;
// otherwise fall through to `originalCartTotal`.

export type PickStoreCartSumInput = {
  originalCartTotal: number | null;
  activeCart?: { amount?: string | number | null } | null;
};

export const pickStoreCartSum = ({
  originalCartTotal,
  activeCart
}: PickStoreCartSumInput): number | null => {
  if (activeCart && activeCart.amount != null) return Number(activeCart.amount);
  return originalCartTotal;
};
